import { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import { TileRadio, IndividualForm, OrganisationForm } from '@components';
import { tile } from '@interfaces/interfaces';
import { iThirdPartyFormValues } from '@services/ThirdPartyService';

import styles from './TPStep3.module.scss';

function TPStep3(): ReactElement {
  const { values }: { values: iThirdPartyFormValues } = useFormikContext();

  const IndividualOption = (): ReactElement => (
    <>
      <div>An individual</div>
    </>
  );

  const OrganisationOption = (): ReactElement => (
    <>
      <div>An organisation</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <IndividualOption />,
      value: 'individual',
    },
    {
      body: <OrganisationOption />,
      value: 'organisation',
    },
  ];

  return (
    <>
      <div>
        <div className="vfH2">Who are you nominating to enquire or act on your behalf?</div>
        <Field
          name="WhoAreYouNominating"
          component={TileRadio}
          tileData={TILE_DATA}
          wrapTiles
          info={{
            caption: 'Your nominee must be over 18 years of age.',
            tileValue: 'individual'
          }}
          orientationRow />
        {values.WhoAreYouNominating && (
          <div className={styles.requiredDetails}>
            <span className={styles.bold}>Required fields</span>
            <br />
            <span className={styles.details}>
              All fields within this form are required unless marked as optional
              <span className={styles.optional}> (optional)</span>
            </span>
            <div className={styles.lineBreak} />
          </div>
        )}
        {values.WhoAreYouNominating === 'individual' && <IndividualForm />}
        {values.WhoAreYouNominating === 'organisation' && <OrganisationForm />}
      </div>
    </>
  );
}

export default TPStep3;
